import { useLocation } from 'react-router';
import { Button } from 'zudoku/ui/Button';

export function HeaderMenu() {
  const { pathname } = useLocation();

  const isApi = pathname.startsWith('/api');
  const isTimeline = pathname.startsWith('/timeline');
  const enHref = isApi ? '/api/en' : isTimeline ? '/timeline/en/changelog' : '/docs/en/introduction';
  const frHref = isApi ? '/api/fr' : isTimeline ? '/timeline/fr/changelog' : '/docs/fr/introduction';

  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" size="sm" asChild>
        <a href={enHref}>EN</a>
      </Button>
      <Button variant="ghost" size="sm" asChild>
        <a href={frHref}>FR</a>
      </Button>
    </div>
  );
}
